var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-tooltip',{attrs:{"disabled":!_vm.formattedHoverValue,"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function({ on }){return [_c('span',_vm._g({},on),[_vm._v(" "+_vm._s(_vm.formattedValue)+" ")])]}}])},[_vm._v(" "+_vm._s(_vm.formattedHoverValue)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }